import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const ClearFilterIcon = (properties: iconType) => (
  <>
    <SvgIcon
      {...properties}
      viewBox="0 0 20 17"
      style={{ fill: 'none', width: '21px', height: '20px' }}
    >
      <path d="M11.7619 14.3832L7.2381 16V7.46707L2 1H17L14.9545 3.72727" />
      <path d="M12.5896 7.49806L16.2014 11.1099" />
      <path d="M12.6538 11.0491L16.2051 7.4978" />
      <path d="M14.3433 13.2726C16.6411 13.2726 18.5039 11.4411 18.5039 9.18173C18.5039 6.92238 16.6411 5.09082 14.3433 5.09082C12.0454 5.09082 10.1826 6.92238 10.1826 9.18173C10.1826 11.4411 12.0454 13.2726 14.3433 13.2726Z" />
    </SvgIcon>
  </>
);

ClearFilterIcon.defaultProperties = {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  strokeMiterlimit: '10',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  stroke: '#78869E',
};

export default ClearFilterIcon;
